
import Vue, { PropType } from 'vue';
import _orderBy from 'lodash/orderBy';
import moment from 'moment';
import Tag from '@/components/Tag/index.vue';
import organizeData, { TableHeader as TableHeaderType } from '@/utils/organizeDataForTable';
import {
  TableContainer, TableHeader, TableRow, Col, ContentIcon, ColText,
} from './styles';

export default Vue.extend({
  components: {
    TableContainer,
    TableHeader,
    TableRow,
    Col,
    ContentIcon,
    ColText,
    Tag,
  },
  props: {
    headers: {
      type: Array as PropType<TableHeaderType[]>,
      required: true,
    },
    data: {
      type: Array as PropType<any>,
      required: true,
    },
    onClickIcon: {
      type: Function as PropType<(value: any) => void>,
      default(value: any) {
        this.clipBoardCopy(value);
      },
    },
    onClickIconD: {
      type: Function as PropType<(value: any) => void>,
      default(value: any) {
        this.$emit('myEvent', value);
      },
    },
    onClick: {
      type: Function as PropType<(evt: Event) => void>,
    },
    icon: {
      type: Object,
      default() {
        return { name: 'Paste', isHover: true, tooltip: 'Copiar' };
      },
    },
    iconD: {
      type: Object,
      default() {
        return { name: 'Cross', isHover: true, tooltip: 'Excluir' };
      },
    },
    orderDefault: {
      type: Object,
      default: () => ({ types: [], keys: [] }),
    },
    isScroll: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: 'auto',
    },
    textWidth: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      orderBy: '',
      values: this.data,
      headersCopy: this.headers,
      dataCopy: [] as any[],
      verify: [] as any,
    };
  },
  computed: {
    datas(): any {
      const [organizedData, indexedHeaders] = organizeData(this.values, this.headersCopy);
      return { organizedData, indexedHeaders };
    },
    hasPositionSticky(): string {
      return this.isScroll ? 'sticky' : 'static';
    },
    hasOverflow(): string {
      return this.isScroll ? 'auto' : 'visible';
    },
  },
  methods: {
    keys(row: any) {
      return Object.keys(row)
        .map((item) => (item !== '$original' ? { value: row[item], key: item } : null))
        .filter(Boolean);
    },
    isTag(item: any) {
      return this.datas.indexedHeaders[item]?.tag;
    },
    isIcon(item: any) {
      return this.datas.indexedHeaders[item]?.icon;
    },
    isDIcon(item: any) {
      return this.datas.indexedHeaders[item]?.iconD;
    },
    isDIconT(item: any) {
      return this.datas.indexedHeaders[item]?.iconDT;
    },
    isLink(item: any) {
      return this.datas.indexedHeaders[item]?.link;
    },
    clipBoardCopy(value: any) {
      this.$copyText(value)
        .then(() => {
          this.$toast.success('Copiado com sucesso!');
        })
        .catch(() => {
          this.$toast.error('Erro ao copiar!');
        });
    },
    orderData(key: string, order: boolean, index: number) {
      this.headersCopy[index].order = order;
      this.mapIndexDifference(key);
      this.orderValues(key, !order ? 'asc' : 'desc');
    },
    orderValues(key: string, orders: 'asc' | 'desc') {
      this.orderBy = key;
      const data = this.datas.organizedData;

      if (this.isValidDate(data[0][key])) {
        this.values = _orderBy(data, (item) => this.formatDateToUnix(item[key]), orders);
        return;
      }

      this.values = _orderBy(this.datas.organizedData, this.orderBy, orders);
    },
    isValidDate(value: any, dateFormat = 'DD/MM/YYYY') {
      return moment(value, dateFormat, true).isValid();
    },
    formatDateToUnix(date: string, format = 'DD/MM/YYYY') {
      return moment(date, format).valueOf();
    },
    mapIndexDifference(key: string) {
      this.headersCopy = this.headersCopy
        .map((item) => {
          const orderItem = item;
          if (item.key !== key) {
            orderItem.order = false;
            orderItem.isStyle = false;
            return orderItem;
          }

          orderItem.isStyle = true;
          return orderItem;
        });
    },

  },
  watch: {
    data() {
      this.values = this.data;
      this.dataCopy = this.values;
    },
  },
  created() {
    this.values = _orderBy(this.datas.organizedData, this.orderDefault.keys, this.orderDefault.types);
    this.dataCopy = this.values;
  },
});
